import React, { ReactElement, useState } from "react";
import { FormattedMessage } from "react-intl";

import Paper from "@mui/material/Paper";
import Slider from "@mui/material/Slider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { ILocations } from "types/api/serversApiInterface";

const CSize = ({
 size,
 setData
}: {
 size: number;
 setData: (section: string, value: string | number | boolean | ILocations) => void;
}): ReactElement => {
 const [sliderSize, setSliderSize] = useState<number>(size);

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left" }}>
   <Typography variant="unboundedTitle" fontSize={18}>
    <FormattedMessage id="addons.cloudbucket.selectSize" />
   </Typography>
   <Stack spacing={2} mt={2}>
    <Typography textAlign="left" variant="subtitle2">
     <FormattedMessage id="addons.cloudbucket.selectSizeMessage" />
    </Typography>
    <Stack direction="row" spacing={2} alignItems="center">
     <Slider
      aria-label="Always visible"
      defaultValue={250}
      value={sliderSize}
      onChange={(_e, nV) => {
       setSliderSize(nV as number);
      }}
      onMouseUp={() => {
       setData("size", sliderSize);
      }}
      step={250}
      max={25000}
      min={250}
      valueLabelDisplay="on"
     />
    </Stack>
   </Stack>
  </Paper>
 );
};

export default CSize;
